// Proxied through next.config.js rewrites so ad blockers don't drop events.
const POSTHOG_PROXY_PATH = '/ingest';

let posthogPromise;

export const initializePostHog = ({ apiKey, apiHost }) => {
  if (!apiKey || !apiHost) {
    return Promise.resolve(null);
  }

  if (!posthogPromise) {
    posthogPromise = import('posthog-js').then(({ default: posthog }) => {
      posthog.init(apiKey, {
        api_host: POSTHOG_PROXY_PATH,
        ui_host: apiHost.replace('.i.posthog.com', '.posthog.com'),
        defaults: '2026-05-30',
        capture_exceptions: {
          capture_unhandled_errors: true,
          capture_unhandled_rejections: true,
          capture_console_errors: false,
        },
      });

      return posthog;
    });
  }

  return posthogPromise;
};

export const getPostHog = () => posthogPromise || Promise.resolve(null);

export const captureEvent = (event, properties) => {
  getPostHog().then((posthog) => posthog?.capture(event, properties));
};
